// src/vendorImports.js
import * as jQ from "jquery";
import Popper from "popper.js";
window.$ = window.jQuery = jQ.default || jQ;
window.Popper = Popper;

// Bootstrap 4：npm 版 (含 Popper)
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap/dist/css/bootstrap.min.css";         // 核心样式

// 模板自带 CSS（从 src/assets 读取）
import "./assets/css/fontawesome.css";
import "./assets/css/templatemo-grad-school.css";
import "./assets/css/owl.css";
import "./assets/css/lightbox.css";
